// extracted by mini-css-extract-plugin
export default {"container":"tHusBC7o","mobile":"mobile","logos":"D57hbD6B","title":"IvB9PC7w","buttons":"_qmK9cAz","attention":"r0__UtZT","description":"CYffo1_W","agreement":"RHlQRi49"};